import React from 'react'
import HeaderOne from "../components/header/HeaderOne";
import Breadcrumb from "./Breadcrumb";
import { Link, useParams } from 'react-router-dom';
import FooterOne from "../components/footer/FooterOne";

// Données des services
const servicesData = {
    'transit': {
        title: 'Transit',
        breadcrumb: 'Transit',
        image: 'assets/images/service/01.jpg',
        description: [
            'GLOBAL-SERVICES CONGO propose des services de transit professionnels pour vos marchandises avec un suivi complet et une gestion optimisée des flux logistiques. Notre expertise couvre tous les aspects du transit international, de la réception à la livraison finale.',
            'Nous assurons la gestion complète de vos opérations de transit, incluant le dédouanement, le stockage temporaire, le transport et la documentation nécessaire. Notre équipe expérimentée travaille en étroite collaboration avec les autorités douanières pour garantir un traitement rapide et efficace de vos marchandises.'
        ],
        features: [
            {
                icon: 'assets/images/service/icon/09.svg',
                title: 'Dédouanement rapide',
                description: 'Traitement accéléré de vos formalités douanières avec notre expertise locale'
            },
            {
                icon: 'assets/images/service/icon/10.svg',
                title: 'Suivi en temps réel',
                description: 'Suivi complet de vos marchandises tout au long du processus de transit'
            },
            {
                icon: 'assets/images/service/icon/11.svg',
                title: 'Gestion documentaire',
                description: 'Prise en charge complète de toute la documentation nécessaire'
            },
            {
                icon: 'assets/images/service/icon/12.svg',
                title: 'Stockage sécurisé',
                description: 'Espaces de stockage sécurisés pour vos marchandises en transit'
            }
        ],
        steps: [
            {
                number: '01',
                title: 'Réception des marchandises',
                description: 'Réception et vérification de vos marchandises à l\'arrivée au port'
            },
            {
                number: '02',
                title: 'Dédouanement',
                description: 'Traitement de toutes les formalités douanières et administratives'
            },
            {
                number: '03',
                title: 'Livraison',
                description: 'Transport et livraison sécurisée à destination finale'
            }
        ],
        benefits: [
            'Gestion complète des formalités douanières',
            'Réduction des délais de transit',
            'Suivi en temps réel de vos marchandises',
            'Conseil et accompagnement personnalisé'
        ]
    },
    'fourniture-materiaux-construction': {
        title: 'Fourniture de matériaux de construction',
        breadcrumb: 'Fourniture de matériaux',
        image: 'assets/images/service/01.jpg',
        description: [
            'Nous proposons un approvisionnement complet en matériaux de construction de qualité pour tous vos projets, avec livraison rapide et prix compétitifs. Notre réseau de fournisseurs nous permet de répondre à tous vos besoins, des matériaux de base aux équipements spécialisés.',
            'Que ce soit pour des projets résidentiels, commerciaux ou industriels, nous mettons à votre disposition une large gamme de matériaux : ciment, acier, bois, carrelage, peinture, et bien plus encore. Tous nos matériaux sont sélectionnés selon les normes de qualité en vigueur.'
        ],
        features: [
            {
                icon: 'assets/images/service/icon/09.svg',
                title: 'Large gamme de produits',
                description: 'Catalogue complet de matériaux de construction de qualité'
            },
            {
                icon: 'assets/images/service/icon/10.svg',
                title: 'Livraison rapide',
                description: 'Service de livraison rapide pour respecter vos délais de chantier'
            },
            {
                icon: 'assets/images/service/icon/11.svg',
                title: 'Prix compétitifs',
                description: 'Tarifs compétitifs grâce à nos partenariats avec les fournisseurs'
            },
            {
                icon: 'assets/images/service/icon/12.svg',
                title: 'Conseil technique',
                description: 'Conseil et accompagnement pour le choix des matériaux adaptés'
            }
        ],
        steps: [
            {
                number: '01',
                title: 'Analyse des besoins',
                description: 'Évaluation de vos besoins et recommandation de matériaux adaptés'
            },
            {
                number: '02',
                title: 'Commande et approvisionnement',
                description: 'Gestion de la commande et approvisionnement auprès de nos fournisseurs'
            },
            {
                number: '03',
                title: 'Livraison sur site',
                description: 'Livraison directement sur votre chantier selon vos contraintes'
            }
        ],
        benefits: [
            'Gamme complète de matériaux de qualité',
            'Livraison rapide et flexible',
            'Prix compétitifs et transparents',
            'Support technique et conseil personnalisé'
        ]
    },
    'construction-btp-genie-civil': {
        title: 'Construction BTP & Génie civil',
        breadcrumb: 'Construction BTP',
        image: 'assets/images/service/01.jpg',
        description: [
            'GLOBAL-SERVICES CONGO réalise vos projets de construction et génie civil avec expertise technique et respect des normes en vigueur. Notre équipe d\'ingénieurs et de techniciens qualifiés prend en charge tous types de projets, de la conception à la réalisation.',
            'Nous intervenons sur des projets variés : bâtiments résidentiels et commerciaux, infrastructures routières, ouvrages d\'art, installations industrielles. Chaque projet est suivi avec rigueur pour garantir qualité, sécurité et respect des délais.'
        ],
        features: [
            {
                icon: 'assets/images/service/icon/09.svg',
                title: 'Expertise technique',
                description: 'Équipe d\'ingénieurs et techniciens qualifiés et expérimentés'
            },
            {
                icon: 'assets/images/service/icon/10.svg',
                title: 'Respect des normes',
                description: 'Conformité totale aux normes de construction en vigueur'
            },
            {
                icon: 'assets/images/service/icon/11.svg',
                title: 'Gestion de projet',
                description: 'Suivi rigoureux de chaque étape du projet jusqu\'à la livraison'
            },
            {
                icon: 'assets/images/service/icon/12.svg',
                title: 'Qualité garantie',
                description: 'Engagement sur la qualité des matériaux et de la réalisation'
            }
        ],
        steps: [
            {
                number: '01',
                title: 'Étude et conception',
                description: 'Analyse du projet, conception et établissement du planning'
            },
            {
                number: '02',
                title: 'Réalisation',
                description: 'Exécution des travaux avec suivi qualité et respect des délais'
            },
            {
                number: '03',
                title: 'Livraison et garantie',
                description: 'Livraison du projet et mise en place de la garantie décennale'
            }
        ],
        benefits: [
            'Expertise technique reconnue',
            'Respect des normes et réglementations',
            'Gestion complète du projet',
            'Garantie qualité et suivi post-livraison'
        ]
    },
    'fourniture-equipements-industriels': {
        title: 'Fourniture d\'équipements et matériels industriels',
        breadcrumb: 'Équipements industriels',
        image: 'assets/images/service/01.jpg',
        description: [
            'Nous proposons des solutions complètes en équipements industriels adaptés à vos besoins, avec installation et maintenance professionnelles. Notre catalogue couvre tous les secteurs industriels : machines-outils, équipements de production, systèmes de manutention, et bien plus.',
            'Notre service inclut non seulement la fourniture d\'équipements, mais aussi leur installation par des techniciens qualifiés, la formation de vos équipes, et un service de maintenance préventive et corrective pour garantir la performance de vos installations.'
        ],
        features: [
            {
                icon: 'assets/images/service/icon/09.svg',
                title: 'Équipements adaptés',
                description: 'Sélection d\'équipements industriels adaptés à vos besoins spécifiques'
            },
            {
                icon: 'assets/images/service/icon/10.svg',
                title: 'Installation professionnelle',
                description: 'Installation par des techniciens qualifiés et expérimentés'
            },
            {
                icon: 'assets/images/service/icon/11.svg',
                title: 'Maintenance',
                description: 'Service de maintenance préventive et corrective pour vos équipements'
            },
            {
                icon: 'assets/images/service/icon/12.svg',
                title: 'Formation',
                description: 'Formation de vos équipes à l\'utilisation des équipements'
            }
        ],
        steps: [
            {
                number: '01',
                title: 'Analyse des besoins',
                description: 'Évaluation de vos besoins et recommandation d\'équipements adaptés'
            },
            {
                number: '02',
                title: 'Fourniture et installation',
                description: 'Livraison et installation professionnelle des équipements'
            },
            {
                number: '03',
                title: 'Formation et maintenance',
                description: 'Formation des équipes et mise en place du plan de maintenance'
            }
        ],
        benefits: [
            'Gamme complète d\'équipements industriels',
            'Installation par des professionnels',
            'Service de maintenance inclus',
            'Formation et support technique'
        ]
    },
    'nettoyage-industriel-assainissement': {
        title: 'Nettoyage industriel & assainissement',
        breadcrumb: 'Nettoyage industriel',
        image: 'assets/images/service/01.jpg',
        description: [
            'Nous proposons des services de nettoyage industriel et assainissement pour maintenir vos espaces de travail propres et sécurisés. Nos équipes utilisent des méthodes et produits adaptés aux environnements industriels, garantissant efficacité et sécurité.',
            'Nos services couvrent tous types d\'espaces : ateliers, entrepôts, bureaux, espaces extérieurs. Nous adaptons nos interventions selon vos besoins : nettoyage régulier, nettoyage approfondi, désinfection, ou nettoyage après travaux.'
        ],
        features: [
            {
                icon: 'assets/images/service/icon/09.svg',
                title: 'Nettoyage professionnel',
                description: 'Méthodes et produits adaptés aux environnements industriels'
            },
            {
                icon: 'assets/images/service/icon/10.svg',
                title: 'Équipes qualifiées',
                description: 'Personnel formé et équipé pour tous types de nettoyage industriel'
            },
            {
                icon: 'assets/images/service/icon/11.svg',
                title: 'Flexibilité',
                description: 'Interventions adaptées à vos contraintes horaires et opérationnelles'
            },
            {
                icon: 'assets/images/service/icon/12.svg',
                title: 'Sécurité',
                description: 'Respect des normes de sécurité et utilisation de produits certifiés'
            }
        ],
        steps: [
            {
                number: '01',
                title: 'Audit des besoins',
                description: 'Évaluation de vos besoins et établissement d\'un plan d\'intervention'
            },
            {
                number: '02',
                title: 'Intervention',
                description: 'Réalisation du nettoyage selon les protocoles établis'
            },
            {
                number: '03',
                title: 'Contrôle qualité',
                description: 'Vérification de la qualité du travail et ajustements si nécessaire'
            }
        ],
        benefits: [
            'Environnement de travail propre et sécurisé',
            'Interventions flexibles selon vos besoins',
            'Équipes qualifiées et équipées',
            'Respect des normes d\'hygiène et de sécurité'
        ]
    },
    'fourniture-equipement-general': {
        title: 'Fourniture d\'équipement général de l\'entreprise',
        breadcrumb: 'Équipement entreprise',
        image: 'assets/images/service/01.jpg',
        description: [
            'Nous fournissons un équipement complet pour votre entreprise avec sélection de matériels adaptés et solutions sur mesure pour votre activité. De l\'ameublement de bureau aux équipements informatiques, en passant par les fournitures, nous couvrons tous vos besoins.',
            'Notre approche personnalisée nous permet de comprendre vos besoins spécifiques et de proposer des solutions adaptées à votre secteur d\'activité et à votre budget. Nous assurons également l\'installation et la maintenance de vos équipements.'
        ],
        features: [
            {
                icon: 'assets/images/service/icon/09.svg',
                title: 'Gamme complète',
                description: 'Équipements de bureau, informatiques, mobilier et fournitures'
            },
            {
                icon: 'assets/images/service/icon/10.svg',
                title: 'Solutions sur mesure',
                description: 'Propositions adaptées à votre secteur d\'activité et vos besoins'
            },
            {
                icon: 'assets/images/service/icon/11.svg',
                title: 'Installation',
                description: 'Installation et configuration de vos équipements par nos techniciens'
            },
            {
                icon: 'assets/images/service/icon/12.svg',
                title: 'Maintenance',
                description: 'Service de maintenance et support technique pour vos équipements'
            }
        ],
        steps: [
            {
                number: '01',
                title: 'Analyse des besoins',
                description: 'Évaluation de vos besoins en équipements et fournitures'
            },
            {
                number: '02',
                title: 'Proposition',
                description: 'Proposition de solutions adaptées avec devis détaillé'
            },
            {
                number: '03',
                title: 'Livraison et installation',
                description: 'Livraison, installation et configuration de vos équipements'
            }
        ],
        benefits: [
            'Gamme complète d\'équipements professionnels',
            'Solutions personnalisées selon vos besoins',
            'Installation et configuration incluses',
            'Support technique et maintenance'
        ]
    },
    'mise-disposition-personnel': {
        title: 'Mise à disposition de personnel',
        breadcrumb: 'Mise à disposition',
        image: 'assets/images/service/01.jpg',
        description: [
            'Nous mettons à votre disposition du personnel qualifié et expérimenté pour répondre à vos besoins temporaires ou permanents en ressources humaines. Que ce soit pour un projet spécifique, un remplacement, ou un renfort d\'équipe, nous vous proposons des profils adaptés à vos exigences.',
            'Notre processus de recrutement rigoureux garantit que chaque personne mise à disposition possède les compétences et l\'expérience nécessaires. Nous couvrons tous les secteurs : administratif, technique, logistique, sécurité, et bien plus.'
        ],
        features: [
            {
                icon: 'assets/images/service/icon/09.svg',
                title: 'Personnel qualifié',
                description: 'Sélection rigoureuse de profils qualifiés et expérimentés'
            },
            {
                icon: 'assets/images/service/icon/10.svg',
                title: 'Flexibilité',
                description: 'Mise à disposition temporaire ou permanente selon vos besoins'
            },
            {
                icon: 'assets/images/service/icon/11.svg',
                title: 'Gestion administrative',
                description: 'Prise en charge complète de la gestion administrative et sociale'
            },
            {
                icon: 'assets/images/service/icon/12.svg',
                title: 'Suivi',
                description: 'Accompagnement et suivi régulier pour garantir la satisfaction'
            }
        ],
        steps: [
            {
                number: '01',
                title: 'Analyse des besoins',
                description: 'Définition précise de vos besoins en compétences et profils'
            },
            {
                number: '02',
                title: 'Sélection',
                description: 'Recrutement et sélection de candidats adaptés à vos exigences'
            },
            {
                number: '03',
                title: 'Mise à disposition',
                description: 'Intégration dans votre équipe et suivi régulier'
            }
        ],
        benefits: [
            'Personnel qualifié et expérimenté',
            'Flexibilité selon vos besoins',
            'Gestion administrative simplifiée',
            'Suivi et accompagnement personnalisé'
        ]
    },
    'transport-logistique': {
        title: 'Transport & logistique',
        breadcrumb: 'Transport & logistique',
        image: 'assets/images/service/01.jpg',
        description: [
            'Nous proposons des solutions complètes de transport et logistique pour optimiser vos chaînes d\'approvisionnement avec suivi en temps réel. Notre expertise couvre tous les modes de transport : routier, maritime, aérien, et nous gérons également le stockage et la distribution.',
            'Notre service de logistique intégrée vous permet de gérer l\'ensemble de votre supply chain depuis un seul point de contact. Nous optimisons vos flux, réduisons vos coûts et améliorons vos délais de livraison.'
        ],
        features: [
            {
                icon: 'assets/images/service/icon/09.svg',
                title: 'Transport multimodal',
                description: 'Solutions de transport routier, maritime et aérien'
            },
            {
                icon: 'assets/images/service/icon/10.svg',
                title: 'Suivi en temps réel',
                description: 'Suivi GPS et système de traçabilité pour vos marchandises'
            },
            {
                icon: 'assets/images/service/icon/11.svg',
                title: 'Optimisation logistique',
                description: 'Optimisation de vos flux et réduction des coûts logistiques'
            },
            {
                icon: 'assets/images/service/icon/12.svg',
                title: 'Stockage',
                description: 'Solutions de stockage et entreposage pour vos marchandises'
            }
        ],
        steps: [
            {
                number: '01',
                title: 'Planification',
                description: 'Analyse de vos besoins et planification optimale des transports'
            },
            {
                number: '02',
                title: 'Exécution',
                description: 'Transport et suivi en temps réel de vos marchandises'
            },
            {
                number: '03',
                title: 'Livraison',
                description: 'Livraison à destination avec confirmation de réception'
            }
        ],
        benefits: [
            'Solutions de transport complètes',
            'Suivi en temps réel de vos marchandises',
            'Optimisation des coûts et délais',
            'Gestion logistique intégrée'
        ]
    },
    'prestations-service-on-off-shore': {
        title: 'Prestations de service On/Off Shore',
        breadcrumb: 'Prestations On/Off Shore',
        image: 'assets/images/service/01.jpg',
        description: [
            'GLOBAL-SERVICES CONGO propose des prestations de service complètes pour les activités pétrolières en mer (Offshore) et à terre (Onshore). Externaliser certaines activités permet aux entreprises d\'optimiser leur fonctionnement et de se concentrer sur leur cœur de métier.',
            'Nous offrons une gamme complète de services de sous-traitance pour le secteur pétrolier, incluant la maintenance, la logistique, le support technique, et la gestion des installations. Notre expertise couvre à la fois les opérations en mer et les installations terrestres, garantissant une continuité de service optimale.'
        ],
        features: [
            {
                icon: 'assets/images/service/icon/09.svg',
                title: 'Services Offshore',
                description: 'Prestations complètes pour les plateformes pétrolières et installations en mer'
            },
            {
                icon: 'assets/images/service/icon/10.svg',
                title: 'Services Onshore',
                description: 'Support technique et logistique pour les installations terrestres'
            },
            {
                icon: 'assets/images/service/icon/11.svg',
                title: 'Maintenance préventive',
                description: 'Programmes de maintenance pour garantir la continuité opérationnelle'
            },
            {
                icon: 'assets/images/service/icon/12.svg',
                title: 'Support technique',
                description: 'Équipes qualifiées disponibles 24/7 pour vos opérations critiques'
            }
        ],
        steps: [
            {
                number: '01',
                title: 'Analyse des besoins',
                description: 'Évaluation de vos besoins en prestations et définition du périmètre d\'intervention'
            },
            {
                number: '02',
                title: 'Mise en place',
                description: 'Déploiement des équipes et des ressources nécessaires sur site'
            },
            {
                number: '03',
                title: 'Exécution et suivi',
                description: 'Réalisation des prestations avec reporting régulier et optimisation continue'
            }
        ],
        benefits: [
            'Optimisation des coûts opérationnels',
            'Concentration sur le cœur de métier',
            'Expertise technique reconnue',
            'Disponibilité 24/7 pour les opérations critiques'
        ]
    }
};

function ServiceDetails() {
    const { id } = useParams();
    const service = servicesData[id];

    // Si le service n'existe pas, rediriger ou afficher un message
    if (!service) {
        return (
            <div className=''>
                <HeaderOne />
                <div className="rts-section-gap" style={{ paddingTop: '100px', textAlign: 'center' }}>
                    <div className="container">
                        <h2>Service non trouvé</h2>
                        <Link to="/" className="rts-btn btn-primary mt--20">
                            Retour à l'accueil
                        </Link>
                    </div>
                </div>
                <FooterOne />
            </div>
        );
    }

    const breadcrumbs = [
        { label: 'Accueil', link: '/' },
        { label: 'Nos Services', link: '/our-service' },
        { label: service.breadcrumb }
    ];

    return (
        <div className=''>
            <HeaderOne />
            <Breadcrumb title={service.title} breadcrumbs={breadcrumbs} />

            {/* start service details area */}
            <div className="rts-service-details-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-md-12 col-sm-12 col-12">
                            {/* service details left area start */}
                            <div className="service-detials-step-1">
                                <h4 className="title">{service.title}</h4>
                                {service.description.map((paragraph, index) => (
                                    <p key={index} className="disc">
                                        {paragraph}
                                    </p>
                                ))}
                                {id === 'prestations-service-on-off-shore' && (
                                    <div className="row g-5 mt--30 mb--30">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/prestation.jpeg" 
                                                alt="Prestation de services onshore/offshore" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/prestation2.jpeg" 
                                                alt="Prestation de services onshore/offshore" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                    </div>
                                )}
                                {id === 'transit' && (
                                    <div className="row g-5 mt--30 mb--30">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/transit.jpeg" 
                                                alt="Service de transit" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/transit2.jpeg" 
                                                alt="Service de transit" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                    </div>
                                )}
                                {id === 'construction-btp-genie-civil' && (
                                    <div className="row g-5 mt--30 mb--30">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/btp.jpeg" 
                                                alt="Construction BTP & Génie civil" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/btp1.jpeg" 
                                                alt="Construction BTP & Génie civil" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                    </div>
                                )}
                                {id === 'fourniture-materiaux-construction' && (
                                    <div className="row g-5 mt--30 mb--30">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/fourniture.jpeg" 
                                                alt="Fourniture de matériaux de construction" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/fourniture1.jpeg" 
                                                alt="Fourniture de matériaux de construction" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                    </div>
                                )}
                                {id === 'fourniture-equipements-industriels' && (
                                    <div className="row g-5 mt--30 mb--30">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/industrie.jpeg" 
                                                alt="Fourniture d'équipements et matériel industriels" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/industrie1.jpeg" 
                                                alt="Fourniture d'équipements et matériel industriels" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                    </div>
                                )}
                                {id === 'nettoyage-industriel-assainissement' && (
                                    <div className="row g-5 mt--30 mb--30">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/nettoyage.jpeg" 
                                                alt="Nettoyage industriel et assainissement" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/nettoyage1.jpeg" 
                                                alt="Nettoyage industriel et assainissement" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                    </div>
                                )}
                                {id === 'fourniture-equipement-general' && (
                                    <div className="row g-5 mt--30 mb--30">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/fourniture_entreprise.jpeg" 
                                                alt="Fourniture d'équipement général de l'Entreprise" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/fourniture_entreprise1.jpeg" 
                                                alt="Fourniture d'équipement général de l'Entreprise" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                    </div>
                                )}
                                {id === 'transport-logistique' && (
                                    <div className="row g-5 mt--30 mb--30">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/transport.jpeg" 
                                                alt="Transport et logistique" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/transport1.jpeg" 
                                                alt="Transport et logistique" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                    </div>
                                )}
                                {id === 'mise-disposition-personnel' && (
                                    <div className="row g-5 mt--30 mb--30">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/disposition.jpeg" 
                                                alt="Mise à disposition du personnel" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                            <img 
                                                src="/assets/images/disposition1.jpeg" 
                                                alt="Mise à disposition du personnel" 
                                                className="img-fluid"
                                                style={{ width: '100%', borderRadius: '8px' }}
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="row g-5 mt--30 mb--40">
                                    {service.features.map((feature, index) => (
                                        <div key={index} className="col-lg-6">
                                        <div className="service-details-card">
                                            <div className="details">
                                                    <h6 className="title">{feature.title}</h6>
                                                <p className="disc">
                                                        {feature.description}
                                                </p>
                                            </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <p className="disc">
                                    GLOBAL-SERVICES CONGO s'engage à vous fournir des services de qualité supérieure, adaptés à vos besoins spécifiques. Notre équipe expérimentée est à votre disposition pour vous accompagner dans tous vos projets et répondre à vos attentes.
                                </p>
                            </div>
                            <div className="service-detials-step-2 mt--40">
                                <h4 className="title">Notre Processus en 3 Étapes</h4>
                                <p className="disc mb--25">
                                    Chez GLOBAL-SERVICES CONGO, nous suivons un processus structuré pour garantir la qualité et l'efficacité de nos services. Chaque étape est soigneusement planifiée et exécutée pour répondre à vos attentes.
                                </p>
                                {/* stem-area start */}
                                <div className="row mb--40 g-5 mb_md--20 mb_sm--20">
                                    {service.steps.map((step, index) => (
                                        <div key={index} className="col-lg-4 col-md-6 col-sm-12 col-12">
                                        <div className="single-service-step text-center">
                                                <p className="step">{step.number}</p>
                                                <h6 className="title">{step.title}</h6>
                                            <p className="disc">
                                                    {step.description}
                                            </p>
                                        </div>
                                        </div>
                                    ))}
                                </div>
                                <p className="disc">
                                    Notre approche méthodique et notre expertise nous permettent de vous offrir des services de qualité, dans les délais convenus et selon vos spécifications. Nous restons à votre écoute tout au long du processus pour vous garantir une satisfaction totale.
                                </p>
                                {/* stem-area End */}
                            </div>
                            {/* service details left area end */}
                            <div className="service-detials-step-3 mt--70 mt_md--50">
                                <div className="row g-5 align-items-center">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb_md--20 mb_sm--20">
                                        <h4 className="title">Avantages pour nos Clients</h4>
                                        <p className="disc">
                                            Choisir GLOBAL-SERVICES CONGO, c'est bénéficier d'un partenaire de confiance qui s'engage à vous offrir des services de qualité, adaptés à vos besoins et à votre budget.
                                        </p>
                                        {service.benefits.map((benefit, index) => (
                                            <div key={index} className="single-banifits">
                                            <i className="far fa-check-circle" />
                                                <span>{benefit}</span>
                                        </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*rts blog wizered area */}
                        <div className="col-xl-4 col-md-12 col-sm-12 col-12 mt_lg--60 pl--50 pl_md--0 pl-lg-controler pl_sm--0">
                            {/* single wizered start */}
                            <div className="rts-single-wized Categories service">
                                <div className="wized-header">
                                    <h5 className="title">Nos Services</h5>
                                </div>
                                <div className="wized-body">
                                    <ul className="single-categories">
                                        <li>
                                            <Link to="/service/prestations-service-on-off-shore">
                                                Prestations On/Off Shore <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="single-categories">
                                        <li>
                                            <Link to="/service/transit">
                                                Transit <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="single-categories">
                                        <li>
                                            <Link to="/service/fourniture-materiaux-construction">
                                                Fourniture de matériaux <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="single-categories">
                                        <li>
                                            <Link to="/service/construction-btp-genie-civil">
                                                Construction BTP <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="single-categories">
                                        <li>
                                            <Link to="/service/fourniture-equipements-industriels">
                                                Équipements industriels <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="single-categories">
                                        <li>
                                            <Link to="/service/nettoyage-industriel-assainissement">
                                                Nettoyage industriel <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="single-categories">
                                        <li>
                                            <Link to="/service/fourniture-equipement-general">
                                                Équipement entreprise <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="single-categories">
                                        <li>
                                            <Link to="/service/mise-disposition-personnel">
                                                Mise à disposition <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                    <ul className="single-categories">
                                        <li>
                                            <Link to="/service/transport-logistique">
                                                Transport & logistique <i className="far fa-long-arrow-right" />
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            {/* single wizered End */}
                            {/* single wizered start */}
                            <div className="rts-single-wized contact service">
                                <div className="wized-header">
                                    <Link to="/">
                                        <img src="assets/images/logo/logo-2.svg" alt="Business_logo" />
                                    </Link>
                                </div>
                                <div className="wized-body">
                                    <h5 className="title">Besoin d'aide ? Nous sommes là pour vous aider</h5>
                                    <Link className="rts-btn btn-primary" to="/contactus">
                                        Contactez-nous
                                    </Link>
                                </div>
                            </div>
                            {/* single wizered End */}
                        </div>
                        {/* rts- blog wizered end area */}
                    </div>
                </div>
            </div>
            {/* End service details area */}

            <FooterOne />
        </div>
    )
}

export default ServiceDetails
